import { Checkbox, FormLabel, Grid, Stack } from '@mui/material';
import useUsers from 'api/useUsers';
import { Coupon } from 'common/contracts';
import AcCard from 'components/AcCard/AcCard';
import AcInput from 'components/AcInput/AcInput';
import { EFeatureFlag } from 'constants/enums';
import { FormikErrors, FormikTouched } from 'formik';
import React from 'react';
import { useParams } from 'react-router-dom';
import { CouponFormValues } from '../../CouponsForm';
import CouponsAllowedPlayersTable from './CouponsAllowedPlayersTable';

interface PlayerSettingCouponsProps {
  couponFormValues: CouponFormValues;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  errors: FormikErrors<Coupon>;
  touched: FormikTouched<Coupon>;
  setFieldValue: (field: string, value: any) => void;
  dup: boolean;
}

export default function CouponsPlayerSettings({
  couponFormValues,
  handleChange,
  handleBlur,
  errors,
  touched,
  setFieldValue,
  dup
}: PlayerSettingCouponsProps) {
  const { publisherId } = useParams();
  const { fetchFeatureFlags } = useUsers({ publisherId });

  const showAllowedPlayers =
    fetchFeatureFlags.data?.featureFlags?.[
      EFeatureFlag.COUPONS_ALLOWED_PLAYERS
    ];

  return (
    <AcCard
      title="Player Settings"
      customStyles={{
        border: '1px solid #cacbd4',
        borderRadius: '4px',
        padding: '1em',
        marginTop: '1em'
      }}
    >
      <Grid container rowSpacing={2} columnSpacing={1.5}>
        <Grid item xs={12} sm={6} md={4}>
          <Stack direction="column">
            <AcInput
              header="Max coupon redemptions per player"
              name="maxRedemptionsPerCustomer"
              value={couponFormValues.maxRedemptionsPerCustomer}
              disabled={couponFormValues.firstTimePurchase}
              onChange={handleChange}
              placeholder="Unlimited"
              onBlur={handleBlur}
              type="number"
              error={
                Boolean(errors.maxRedemptionsPerCustomer) &&
                (touched.maxRedemptionsPerCustomer || dup)
              }
              helperText={
                touched.maxRedemptionsPerCustomer || dup
                  ? errors.maxRedemptionsPerCustomer?.toString()
                  : ''
              }
            />
            <Stack direction="row" alignItems="center">
              <Checkbox
                checked={!!couponFormValues.firstTimePurchase}
                onClick={(e) => {
                  setFieldValue(
                    'firstTimePurchase',
                    !couponFormValues.firstTimePurchase
                  );
                }}
                name="active"
                sx={{
                  marginLeft: '-10px'
                }}
              />
              <FormLabel
                sx={{
                  cursor: 'pointer'
                }}
                onClick={() => {
                  setFieldValue(
                    'firstTimePurchase',
                    !couponFormValues.firstTimePurchase
                  );
                }}
              >
                Limit to first time buyers
              </FormLabel>
            </Stack>
          </Stack>
        </Grid>
      </Grid>
      {showAllowedPlayers && (
        <CouponsAllowedPlayersTable
          couponFormValues={couponFormValues}
          setFieldValue={setFieldValue}
        />
      )}
    </AcCard>
  );
}
